import {Menu as AntdMenu} from 'antd';

export const Menu = AntdMenu;
